import React, { useEffect, useState } from "react";
import { postTodosLosPaquetes } from "../../../services/PaginaRuta";
import Loading from "../../Loading";
import TablaSeleccionPaquetes from "./TablaSeleccionPaquetes";

const ModalSeleccionPaquetes = ({setmodalOnSeleccionardePaquete, setmodalOnPaquetes, idCirugia, passActualizarTablaPaquetes}) => {
  const [dataPaquetes, setDataPaquetes]=useState([])
  const [loading, setLoading]= useState(false)
  const handleCancelarClick = () => {
    //setmodalOnSeleccionardePaquete(false)
    setmodalOnPaquetes(false)
  };

  //const passActualizarPaquete=(data)=
  const handleOnsubmitBuscarPaquete=(e)=>{
    e.preventDefault()
    const body={
      varPaqInd:'P',
      varPaqTip:'Q',
      varPaqIndAct:'S',
      PaqCod: e.target.codigo.value,
      PaqDes: e.target.descripcion.value
    }
    //console.log(body,'ceper')
    postTodosLosPaquetes(body).then((res)=>
    {
      setDataPaquetes(res.data)
      //console.log(res.data,'paquetes')
    })

  }
    
  

  useEffect(()=>{
    const body={
      varPaqInd:'P',
      varPaqTip:'Q',
      varPaqIndAct:'S',
      PaqCod: '',
      PaqDes: ''
    }
    postTodosLosPaquetes(body).then((res)=>
    {
      setDataPaquetes(res.data)
      setTimeout(() => {          
        setLoading(true);
      }, 1000);
      //console.log(res.data,'paquetes')
    })
  },[])
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto  bg-[#f4f6fa]"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%)] max-w-7xl  mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md bg-[#9e56fe]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Selección Paquetes
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div className="flex-auto overflow-y-auto relative p-2">
            <form onSubmit={handleOnsubmitBuscarPaquete}>
            <div className="flex py-1 text-left">
              <div className="w-2/5  px-1 ">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                  Código
                </label>
                <input
                autoComplete="off"
                name="codigo"
                  type="text"
                  className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                  id="exampleFormControlInput1"
                  placeholder=""
                />
              </div>
              <div className="w-2/5  px-1 ">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                  Descripción
                </label>
                <input
                autoComplete="off"
                name="descripcion"
                  type="text"
                  className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                  id="exampleFormControlInput1"
                  placeholder=""
                />
              </div>
              <div className="w-1/5  px-1 ">
                <label className="form-label block mb-2 text-gray-900 font-medium pt-6">
                  
                </label>
                <button
                  type="submit"
                  className="inline-block px-4 py-1.5 bg-[#9e56fe] text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                >
                  Buscar
                </button>
              </div>
            </div>
            </form>
            <div className="flex flex-col">
              <div className="overflow-x-auto ">
                <div className="py-1 inline-block min-w-full sm:px-1 ">
                  <div className="overflow-hidden">
                    <table className="min-w-full text-center">
                      <thead className="border-b bg-gray-200">
                        <tr>
                        <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-2"
                          >
                            
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-2"
                          >
                            Código
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-2"
                          >
                            Descripción
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading?
                          dataPaquetes.map((item,index)=>(
                            <TablaSeleccionPaquetes key={index} item={item} idCirugia={idCirugia} passActualizarTablaPaquetes={passActualizarTablaPaquetes}/>
                          ))
                          :
                          <tr>
                            <td></td>                      
                            <td className='text-center'><Loading/></td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-1 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-3 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cerrar
            </button>
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalSeleccionPaquetes;
